
import {Vue, Component} from 'vue-property-decorator';
import {queryReplaceDetail, replaceFactoryInvoice} from "@/api/invoice/index";

@Component({name: 'ChangeInvoice'})
export default class ChangeInvoice extends Vue {
  private current: any = {};
  private headInfo: any = {};
  private showDialog = false;
  private confirmLoading = false;
  private selectedRowKey = '';
  private tableData = [];
  private tableLoading = false;
  private exchange = true;
  private codeKeyword = '';

  private handleRowClick(row: any) {
    this.selectedRowKey = row.id
  }

  public async openDialog(row) {
    this.current = row;
    const res = await queryReplaceDetail(row.id, { codeKeyword: this.codeKeyword }) as any;
    this.headInfo = res;
    this.tableData = res.details;
    this.showDialog = true;
  }

  public async getList() {
    await queryReplaceDetail(this.current.id, { codeKeyword: this.codeKeyword }).then((res: any) => {
      this.tableData = res.details;
    }).finally(() => {
      this.tableLoading = false;
    })
  }

  private async handleSubmit() {
    this.confirmLoading = true;
    const data = {
      replaceId: this.selectedRowKey,
      swap: this.exchange,
    }
    await replaceFactoryInvoice(this.current.id, data)
        .then(() => {
          this.$message({
            message: this.current.code + '换资料成功',
            type: 'success'
          });
          this.showDialog = false;
          this.$emit('changeDone');
        })
        .finally(() => {
          this.confirmLoading = false;
        });
  }

  private close() {
    this.selectedRowKey = "";
    this.showDialog = false;
  }
}
